// extracted by mini-css-extract-plugin
module.exports = {"item":"RewardsPageCryptoWallet__item__rTcOL"};